import { useEffect, useState } from "react";
import { MemberPlans } from "../../../../types/memberPlans";
import { getMemberPlans } from "../../../../client/watch/live";
import { ErrorState } from "../../../States/states";
import { FlatList, Platform, useWindowDimensions, View } from "react-native";
import { Plan } from "./Plan";
import { useAtom } from "jotai";
import { cmsDataAtom } from "../../../../atoms";
import { APIResponse } from "../../../../types/responses/APIResponse";

type Props = {
  limit?: number;
};

export const PlansSection = ({ limit }: Props) => {
  // hide plans on ios
  if (Platform.OS === "ios") return;

  // State
  const [response, setResponse] = useState<MemberPlans>();
  const [error, setError] = useState(null);
  const [contentLoading, setContentLoading] = useState(true);
  const [cmsData] = useAtom(cmsDataAtom);

  // Layout
  const { width } = useWindowDimensions();
  const count = response?.available_plans?.length;

  let numColumns = 1;
  if (width < 500) numColumns = 1;
  else if (count >= 4 && 500 < width && width < 1000) numColumns = 2;
  else numColumns = count;

  const fetchPlans = async () => {
    getMemberPlans()
      .then((res: APIResponse<MemberPlans>) => {
        setResponse(res);
      })
      .catch((err) => setError(err))
      .finally(() => setContentLoading(false));
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  // show loading state if data fetch is not complete
  if (contentLoading) return <></>;

  // show error state if data fetch is complete and there is an error
  if (error)
    return <ErrorState message="Sorry, could not retrieve member plans." />;

  // hide plans if there are no plans returned from the api
  // grid layout doesn't play so nice on native :(
  if (!response?.available_plans) return;

  const currencyMap = {
    GBP: "£",
    EUR: "€",
  };

  return (
    <FlatList
      data={response.available_plans
        .slice(0, limit || response.available_plans.length)
        .filter((p) => {
          if (
            p.name === "Free Day Pass" &&
            !cmsData?.settings?.free_day_pass_enabled
          ) {
            return false;
          } else return true;
        })}
      key={numColumns}
      numColumns={numColumns}
      columnWrapperStyle={numColumns > 1 ? { gap: 12 } : undefined}
      contentContainerStyle={[
        {
          gap: 12,
          maxWidth: Platform.OS === "web" ? 1200 : undefined,
        },
        Platform.OS == "web" ? { alignSelf: "center" } : {},
      ]}
      keyExtractor={(item) => item.id}
      renderItem={({ item }) => (
        <Plan
          // key={index}
          currency={currencyMap[response?.currency_code]}
          {...item}
        />
      )}
    />
  );
};
